"use strict";
// Tableau expects the connector to be loaded synchronously, prior to DOMContentLoaded, so we use require() instead of import()
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
require("./bootstrap");
import('./loadSVGAssets');
